import Vue from "vue";
import configs from "../configs";

const ip = configs.apiBase;

const retrieveRegimesFederais = (params) => {
  return Vue.prototype.$http.get(`${ip}/empresa/v1/regime/federal/tipos`);
};

const retrieveTabelasSimples = () => {
  return Vue.prototype.$http.get(
    `${ip}/empresa/v1/regime/federal/simples/tabelas`,
  );
};

const retrieveRegimesEstaduais = () => {
  return Vue.prototype.$http.get(`${ip}/empresa/v1/regime/estadual/tipos`);
};

export default {
  retrieveTabelasSimples,
  retrieveRegimesFederais,
  retrieveRegimesEstaduais,
};
